import { Component, Vue } from "vue-property-decorator";
import { $putReadNotificationList } from "@/api/notification";

@Component
export default class IBNotificationRead extends Vue {

	readNotificationIds: number[] = []

	readNotificationTimerId: number | null = null

	readNotificationDelay: number = 250

	// Need realization in component
	readNotifications(ids: number[]) {}

	async requestToReadNotifications() {
		const readIds = [ ...this.readNotificationIds ];

		if (!readIds.length) return;

		const read = await $putReadNotificationList(readIds, { disableLoader: true });

		if (read) {
			this.readNotifications(readIds);
			this.removeReadNotificationIds(readIds);
		}
	}

	removeReadNotificationIds(ids: number[]) {
		for (let i = 0; i < this.readNotificationIds.length; i++) {
			const indexInIds = ids.indexOf(this.readNotificationIds[i]);

			if (indexInIds > -1) {
				ids.splice(indexInIds, 1);
				this.readNotificationIds.splice(i, 1);

				this.removeReadNotificationIds(ids);

				break;
			}
		}
	}

	addReadNotificationIds(ids: number[]) {
		this.readNotificationIds.push(...ids);

		this.resetNotificationTimer();
	}

	resetNotificationTimer() {
		if (this.readNotificationTimerId) clearTimeout(this.readNotificationTimerId);

		this.readNotificationTimerId = setTimeout(
			() => this.requestToReadNotifications(),
			this.readNotificationDelay
		);
	}

}